export const FETCH_JOBS_FROM_URL_LOADING = 'aiJobs/FETCH_JOBS_FROM_URL_LOADING'
export const FETCH_JOBS_FROM_URL_SUCCESS = 'aiJobs/FETCH_JOBS_FROM_URL_SUCCESS'
export const FETCH_JOBS_FROM_URL_FAILURE = 'aiJobs/FETCH_JOBS_FROM_URL_FAILURE'

export const fetchJobsFromUrlLoading = () => ({ type: FETCH_JOBS_FROM_URL_LOADING })
export const fetchJobsFromUrlSuccess = payload => ({ type: FETCH_JOBS_FROM_URL_SUCCESS, payload })
export const fetchJobsFromUrlFailure = payload => ({ type: FETCH_JOBS_FROM_URL_FAILURE, payload })

export const fetchJobsFromUrl = (urls) => {
    return async dispatch => {
        dispatch(fetchJobsFromUrlLoading())
        
        try {
            // Simulate API call delay
            await new Promise(resolve => setTimeout(resolve, 2000))
            
            // Generate mock jobs for the provided URLs
            const jobTitles = [
                'Internal Medicine Physician', 'Emergency Medicine Physician', 'Family Medicine Physician', 
                'Cardiologist', 'Pediatrician', 'Surgeon', 'Radiologist', 'Anesthesiologist',
                'Psychiatrist', 'Dermatologist', 'Orthopedic Surgeon', 'Neurologist', 'Oncologist',
                'Pathologist', 'Gastroenterologist', 'Pulmonologist', 'Endocrinologist', 'Rheumatologist',
                'Nurse Practitioner - Family Medicine', 'Nurse Practitioner - Emergency', 'Nurse Practitioner - Pediatrics',
                'Physician Assistant - Surgery', 'Physician Assistant - Emergency', 'Physician Assistant - Internal Medicine'
            ]
            
            const cities = ['San Francisco', 'New York', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'Los Angeles', 'Seattle', 'Denver', 'Miami']
            const states = ['CA', 'NY', 'IL', 'TX', 'AZ', 'PA', 'CA', 'WA', 'CO', 'FL']
            
            const mockJobs = urls.flatMap((url, urlIndex) => {
                // Generate 25 jobs per URL
                const jobsPerUrl = Array.from({ length: 25 }, (_, jobIndex) => {
                    const globalJobIndex = urlIndex * 25 + jobIndex
                    const isComplete = Math.random() > 0.3 // 70% complete, 30% need review
                    const candidateTypeId = [1, 2, 3][Math.floor(Math.random() * 3)]
                    const cityIndex = Math.floor(Math.random() * cities.length)
                    
                    return {
                        id: `job-${globalJobIndex}`,
                        sourceUrl: url,
                        // Required fields
                        title: jobTitles[globalJobIndex % jobTitles.length],
                        candidateTypeId: isComplete ? candidateTypeId : (Math.random() > 0.5 ? null : candidateTypeId),
                        practiceType: isComplete ? ['FullTime', 'PartTime', 'Contract', 'Locum'][Math.floor(Math.random() * 4)] : (Math.random() > 0.4 ? null : 'FullTime'),
                        city: cities[cityIndex],
                        state: states[cityIndex],
                        salaryType: isComplete ? ['Annual', 'Hourly'][Math.floor(Math.random() * 2)] : (Math.random() > 0.4 ? null : 'Annual'),
                        salaryMin: isComplete ? Math.floor(Math.random() * 200000) + 150000 : (Math.random() > 0.4 ? null : 250000),
                        salaryMax: isComplete ? Math.floor(Math.random() * 100000) + 300000 : (Math.random() > 0.4 ? null : 350000),
                        // Optional fields
                        about: `Excellent opportunity for a ${jobTitles[globalJobIndex % jobTitles.length]} to join our healthcare team.`,
                        aboutRaw: `Excellent opportunity for a ${jobTitles[globalJobIndex % jobTitles.length]} to join our healthcare team.`,
                        specialtyIds: Math.random() > 0.3 ? [Math.floor(Math.random() * 6) + 1] : [],
                        subspecialtyIds: Math.random() > 0.7 ? [Math.floor(Math.random() * 4) + 1] : [],
                        visaIds: Math.random() > 0.5 ? [Math.floor(Math.random() * 4) + 1] : [],
                        loanForgiveness: Math.random() > 0.5 ? ['Yes', 'No'][Math.floor(Math.random() * 2)] : null,
                        pslfCompatible: Math.random() > 0.5 ? ['Yes', 'No'][Math.floor(Math.random() * 2)] : null,
                        area: Math.random() > 0.3 ? ['Urban', 'Suburban', 'Rural'][Math.floor(Math.random() * 3)] : null,
                        academicType: Math.random() > 0.4 ? ['Academic', 'Community', 'Private Practice'][Math.floor(Math.random() * 3)] : null,
                        shiftType: candidateTypeId === 2 && Math.random() > 0.6 ? ['Day', 'Night', 'Rotating'][Math.floor(Math.random() * 3)] : null,
                        link: Math.random() > 0.6 ? `https://example.com/job-${globalJobIndex}` : '',
                        needsReview: !isComplete // Mark as needs review if missing required fields
                    }
                })
                
                return jobsPerUrl
            })
            
            dispatch(fetchJobsFromUrlSuccess(mockJobs))
            return mockJobs
        } catch (error) {
            dispatch(fetchJobsFromUrlFailure(error.message))
            throw error
        }
    }
}

const initialState = { 
    jobs: [], 
    loading: false,
    error: null
}

export function aiJobReducer(state = initialState, action) {
    switch (action.type) {
    case FETCH_JOBS_FROM_URL_LOADING:
        return { ...state, loading: true, error: null }
    case FETCH_JOBS_FROM_URL_SUCCESS:
        return { jobs: action.payload, loading: false, error: null }
    case FETCH_JOBS_FROM_URL_FAILURE:
        return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

